<template>
  <div class="container">
    <el-card>
      <el-row type="flex" justify="space-between">
        <el-col :span="12">
          <div>
            <el-avatar shape="square" size="large" :src="data.avatar || ''"/>
            <div>昵称: {{ data.nickname }} </div>
            <div>UID: {{ data.id }} </div>
            <div>手机号: {{ data.mobile }} </div>
            <div>注册时间: {{ data.time }} </div>
            <div>邀请人ID: {{ data.invite_id }} </div>
            <div>客服: {{ data.customer_service.name }} </div>
            <!-- <div>规划师: {{ data.planner }} </div> -->
            <div>
              所处环节: 
              <el-select v-model="editStatus" label="状态" @change="onChange" size="mini" >
                <el-option
                  v-for="item in statusList"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <el-row type="flex" >
            <div class="body-container">
              <el-tag
                v-for="item in data.customer_service.tag_list"
                :key="item.id"
                type="success"
                size="mini"
                >
                {{ item.name }}
              </el-tag>
            </div>
            
          </el-row>
        </el-col>
        <el-popover
          placement="right"
          width="500"
          v-model="showEditForm"
          @show="handleShowTagList"
          class="tag-more"
          >
          <div v-for="(group, key) in tagList" :key="key">
            <el-row>
              <el-col>
                <div class="tag-group-label">
                  <span> {{ formatGroupName(key) }} </span>
                </div>
              </el-col>
              <el-tag
                v-model="item.enabled"
                v-for="(item, index) in group"
                :key="item.id"
                :effect="item.enabled ? 'dark' : 'plain'"
                @click="handleClick(item, key, index)"
                size="mini">
                {{ item.name }}
              </el-tag>
            </el-row>
            
          </div>
          <div style="text-align: right; margin: 10px 0">
            <el-button type="" size="mini" @click="handleCancel">取消</el-button>
            <el-button type="primary" size="mini" @click="handleSaveTag">确定</el-button>
          </div>
          <!-- <el-button slot="reference" size="mini">修改标签</el-button> -->
          <div slot="reference" > <i class="el-icon-d-arrow-right"></i></div>
          
        </el-popover>
      </el-row>

    </el-card>
  </div>
</template>

<script>
import request from '../../../api/request';

  const initStatus = [
    {
      value: 0,
      name: '新分配'
    },
    {
      value: 50,
      name: '正在联系'
    },
    {
      value: 100,
      name: '已建立联系'
    },
    {
      value: 200,
      name: '准备成交'
    },
    {
      value: 300,
      name: '已成交'
    },
    {
      value: 900,
      name: '放弃'
    }
  ]
  export default {
    name: 'UserInfo',
    components: {  },
    props: {
      data: {
        type: Object,
        default: function () {
          return {
            nickname: null,
            id: null,
            mobile: null,
            time: null,
            customer_service: {
              member_id: null,
              member_role: null,
              mp_code: null,
              name: null,
              status: null,
              wc_code: null,
              tag_ids: null
            }
          }
        }
      },
      showEdit: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        editStatus: null,
        statusList: initStatus,
        editTagList: [],
        tagList: {},
        tagGroupList: []
      }
    },
    computed: {
      showEditForm: {
        get() {
          return this.showEdit
        },
        set(v) {
          this.$emit('change-show', v)
        }
      }
    },
    created() {
      this.getTagList()
      this.getTagGroup()
    },
    updated() {
      this.editStatus = this.data.customer_service.status
    },
    methods: {
      onChange(form) {
        this.editStatus = form
        this.$emit('change-save', { id: this.data.customer_service.id, status: this.editStatus })
      },
      getTagList() {
        request.cs
          .post('tag_list', {range: [0, 200]})
          .then(response => {
            this.tagList = {}
            response.data.list.forEach(i => {
              if (!this.tagList.hasOwnProperty(i.series_id)) {
                this.$set(this.tagList, i.series_id, [])
              }
              let tags = this.tagList[i.series_id]
              tags.push(Object.assign(i, {enabled: false }))

              this.$set(this.tagList, i.series_id, tags)
            })
          })
      },
      getTagGroup() {
        request.cs
          .post('tag_series_list', {range: [0, 200]})
          .then(response => {
            this.tagGroupList = response.data.list
          })
      },
      getStatusName(value) {
        const status = this.statusList.find(item => item.value === value)
        return status ? status.name : ''
      },
      handleSelectionChange(val) {
        this.editTagList = val
      },
      handleSaveTag() {
        let tags = []
        Object.keys(this.tagList).forEach(g => {
          this.tagList[g].forEach(t => {
            if (t.enabled) {
              tags.push(t.id)
            }
          })
        })
        this.$emit('change-tags-update', {id: this.data.customer_service.id, tag_ids: tags})
      },
      handleCancel() {
        this.$emit('change-show', false)
      },
      handleClick(row, group, index) {
        row.enabled = !row.enabled 
        let tags = this.tagList[group]
        tags[index] = row
        this.$set(this.tagList, group, tags)
      },
      handleShowTagList() {
        this.formatTagList()
      },
      formatTagList() {
        Object.keys(this.tagList).forEach(g => {
          this.tagList[g].forEach(i => {
            let tag = this.data.customer_service.tag_list.find(item => item.id === i.id)
            i.enabled = !!tag
          })
        })
      },
      formatGroupName(key) {
        let g = this.tagGroupList.find(i => i.id === ~~key)
        return g ? g.name : ''
      }
    }
  }
</script>
<style scoped>
.container {
  padding: 5px;
}
.body-container {
  display: flex;
  flex-flow: row wrap;
}
.el-tag {
  margin: 5px 5px;
}
.tag-group-label {
  margin: 10px 10px;
}
.tag-more {
  display: flex;
  align-items: center;
}
</style>